import {Signal} from "../core/Signal";
import {Optionable, OptionableData} from "./Optionable";
import {SceneItem} from "./SceneItem";
import {SceneItemButton} from "./SceneItemButton";

export class InteractiveSceneItem extends SceneItem {

    public readonly isButton?: boolean;
    public readonly onClick = Signal<(item: InteractiveSceneItem) => void>();

    private _button?: SceneItemButton;

    get button(): SceneItemButton | undefined {
        return this._button;
    }

    public onLayout() {
        super.onLayout();
        if (this.isButton) {

            this._button = this.addChild(new SceneItemButton(this));
            this._button.onClick.add(() => {
                this.onClick(this);
            });
            for (const item of this.items) {
                this._button.visuals.addChild(item);
            }
        }
    }

    protected createSceneItem(data?: OptionableData): Optionable {
        return new InteractiveSceneItem();
    }
}
